import { Button, styled } from "@mui/material";
import styled2 from "@emotion/styled";

const HeaderLabel = styled2.header`
    background-color: #41DBCE;
    color: #FFFFFF;
    height: 3rem;
    font-size: 1.5rem;
    padding-top: 0.5rem;
    padding-left: 4rem;
`;

const ReturnButton = styled(Button)(() => ({
    backgroundColor: '#F2F2F2',
    color: '#595959',
    textAlign: 'left',
    fontSize: '1.2rem',
    height: '3.2rem',
    width: '17rem',
    borderRadius: '100rem',
}));

export { HeaderLabel, ReturnButton }
